<template>
        <!-- Footer
        ============================================= -->
        <footer id="footer" class="dark">
          <div id="copyrights">
            <div class="container-fluid">

              Copyrights &copy; Terri Ann Creative, LLC. 2017 | All Rights Reserved

            </div>
          </div>
        </footer><!-- #footer end -->
</template>

<script>
export default {
  name: 'footer',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#copyrights {
    background-color:#111;
}
</style>



// WEBPACK FOOTER //
// footer.vue?97feb2cc